import React, { useState, useEffect } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Button,
  Modal,
  ModalHeader
} from "reactstrap"
import BootstrapTable from 'react-bootstrap-table-next'
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit'
import paginationFactory from 'react-bootstrap-table2-paginator'
import rest from '../../../lib/rest'
import FormEstabelecimento from './formEstabelecimento'
import rotas from '../../../services/rotas'
import useToggle from "../../../lib/useToggle"
import Loading from 'lib/loading'

const CadastroEstabelecimentos  = () => {
  const colunas = [
    {
      dataField: 'estabelecimento_id',
      text: 'Código'
    },
    {
      dataField: 'estabelecimento',
      text: 'Estabelecimento'
    }
  ]

  const { SearchBar }             = Search
  const [modal, setModal]         = useToggle()
  const [loading, setLoading]     = useState(true)

  //dados lista Estabelecimentos
  const [listaEstabelecimento, setListaEstabelecimento] = useState([])
  const [estabelecimento_id, setEstabelecimento_id]     = useState('')

  const listaEstabelecimentos = () => {
    let lista = []
    const url = rotas.estabelecimento
    try{
      const retorno = rest.get(url)
      retorno.then(ret => {
        // console.log(ret)
        if (ret.success && ret.success === 'S'){
          lista = ret.lista
          setListaEstabelecimento(lista)
        }
        setLoading(false);
      })
      return (lista)

    }catch(err){

    }
  }

  useEffect(() => {
    const load = loading;
    if (load === true) {
      listaEstabelecimentos();
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  //limpa formulario
  const abreModal = (estabelecimento_id) => {
    setEstabelecimento_id(estabelecimento_id)
    setModal()
  }

  useEffect(() => {
    if(modal===false){
      listaEstabelecimentos()
    }
  }, [modal])

  if (loading) {
    return (
      <Loading
        tipo='paginas'
      />
    )
  }else {
    return (
      <div className="content">
        <Container>
          <Row>
            <Col md="12" className="p-0">
              <Card>
                <CardHeader>
                  <Row>
                    <Col>
                      <CardTitle>CADASTRO DE ESTABELECIMENTOS</CardTitle>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>

                  <Modal
                    size    = 'lg'
                    isOpen  = {modal}
                  >
                    <ModalHeader>Cadastro de Estabelecimentos</ModalHeader>

                    <FormEstabelecimento
                      fechaModal          = {setModal}
                      estabelecimento_id  = {estabelecimento_id}
                    >
                    </FormEstabelecimento>

                  </Modal>

                  <ToolkitProvider
                    search
                    keyField  = "estabelecimento_id"
                    data      = {listaEstabelecimento}
                    columns   = {colunas}
                  >
                    {
                      props => (
                        <div>
                          <Container>
                            <Row>
                              <Col md="3">
                                <Button
                                  outline
                                  className = "m-0 w-100"
                                  color     = "primary"
                                  style     = {{ padding: '5px 20px' }}
                                  onClick   = {() => abreModal('')}
                                >
                                  <i className="fas fa-plus" />
                                  Cadastrar
                                </Button>
                              </Col>

                              <Col md="9">
                                <SearchBar
                                  placeholder = "Buscar Estabelecimento..."
                                  style       = {{ padding: '5px' }}
                                  {...props.searchProps}
                                />
                              </Col>
                            </Row>
                          </Container>

                          <hr/>

                          <BootstrapTable
                            striped
                            keyField          = 'estabelecimento_id'
                            noDataIndication  = "Nenhum registro encontrado"
                            rowStyle          = {{ cursor: "pointer" }}
                            pagination        = {paginationFactory({
                                                  sizePerPage: 10,
                                                  hideSizePerPage: true,
                                                  hidePageListOnlyOnePage: true,
                                                  showTotal: false,
                                                })}
                            rowEvents         = {{onDoubleClick: (e, row, rowIndex) => {
                                                    abreModal(row.estabelecimento_id)
                                                  }
                                                }}
                            {...props.baseProps}
                          />
                          <br />
                        </div>
                      )
                    }
                  </ToolkitProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default CadastroEstabelecimentos;